var _path, _circle, _circle2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginDecos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 600,
    viewBox: "0 0 720 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.713 129.618C75.0754 154.368 122.672 200 79.0267 200C35.3815 200 0 165.373 0 122.657C0 79.9422 15.8054 29.8461 117.75 3.54975C219.694 -22.7466 296.35 104.869 185.713 129.618Z",
    fill: "#3D4863"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 107,
    r: 40,
    fill: "#0B2878"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 648,
    cy: 159,
    r: 20,
    fill: "#0B2878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M556.819 471.621C642.494 419.783 597.973 400 633.609 400C669.244 400 720 493.739 720 524.125C720 554.511 717.379 578.841 634.143 597.548C550.907 616.254 471.143 523.46 556.819 471.621Z",
    fill: "#A3ACC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.863 518.399C68.534 446.718 91.9732 448.666 106.037 466.197C120.1 483.727 137.999 499.31 162.291 502.816C186.582 506.322 190.527 544.934 144.233 563.222C97.9395 581.509 53.192 590.08 60.863 518.399Z",
    fill: "#0B2878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginDecos);
export default __webpack_public_path__ + "static/media/login-decos.af40855bf6f4754c63ea037ac477d85d.svg";
export { ForwardRef as ReactComponent };